import styles from './loading-screen.module.css';
import { Spinner } from './spinner';

export interface LoadingScreenProps {
  progress: number; // 0-100
  message?: string;
}

export function LoadingScreen({ progress, message = 'Loading assets...' }: LoadingScreenProps) {
  return (
    <div 
      className={styles.loadingScreen}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <Spinner size="md" />
      <div className={styles.loadingTitle}>Loading Story</div>
      <div className={styles.progressContainer}>
        <div 
          className={styles.progressBar}
          role="progressbar"
          aria-valuenow={Math.round(progress)}
          aria-valuemin={0}
          aria-valuemax={100}
        >
          <div 
            className={styles.progressFill} 
            style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
          />
        </div>
        <div className={styles.progressText}>
          {message} {Math.round(progress)}%
        </div>
      </div>
    </div>
  );
}

